import React from "react";
import Navbar from "../components/navbar";
import Hero from "../components/hero";
import Footer from "../components/footer";
import Card from "../components/card";
import underlay1 from "../assets/underlay1.png";
import underlay2 from "../assets/underlay2.png";
import profilePic from "../assets/profile.jpeg";
import blank from "../assets/blank.png";
import individualIcon from "../assets/icons/individual.svg";
import virtualIcon from "../assets/icons/virtual.svg";
import psychometricIcon from "../assets/icons/psychometric.svg";
import subjectChoiceIcon from "../assets/icons/subjectchoice.svg";
import careerIcon from "../assets/icons/career.svg";
import Equestrian from "../assets/icons/equestrian.svg";
import "../styles/universal.css";
import "../styles/landingPage.css";

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Navbar />
      <Hero
        title="Welcome to Erin Robinson Counselling"
        subtitle="I offer professional counselling, psychometric assessments, and sport psychology to support wellbeing and performance."
        quote="The meaning of life is to give life meaning."
        quoteAuthor="Viktor E. Frankl"
      />

      <div className="practice-information-section">
        <h1>Practice Information</h1>
        <div className="card-props-container">
          <div className="card-prop">
            <Card
              image={underlay1}
              title="Contact Information"
              description="To schedule an appointment, /n please email erinrobinsoncounselling@gmail.com or WhatsApp +27 71 496 7512"
              learn="Learn More"
            ></Card>
          </div>
          <div className="card-prop">
            <Card
              image={underlay2}
              title="Location"
              description="The Space Holistic Wellness Centre, /n 577 Rossouw Street, /n Die Wilgers, /n Pretoria, /n 0184"
            ></Card>
          </div>
        </div>
      </div>

      <div className="about-me-underlay">
        <h1>About Me</h1>
        <div className="about-me-section">
          <div className="about-me-image">
            <img src={profilePic} alt="About Me"></img>
          </div>
          <div className="about-me-text">
            <p>
              As an HPCSA Registered Counsellor, my work centres on helping
              people navigate the everyday complexities of life’s journey.
              <br />
              Whether you’re seeking insight, practical coping tools, or simply
              someone to talk to, you’re welcome here. I offer counselling
              services, psychometric testing and I have a special interest in
              sport psychology.
              <br />I work with clients from all persuasions and walks of life,
              and I’m committed to creating a space where everyone feels seen,
              respected, and supported.
            </p>
          </div>
        </div>
      </div>

      <div className="services-section">
        <h1>Services Offered</h1>
        <div className="card-props-container">
          <div className="card-props-top">
            <div className="card-prop">
              <Card
                image={blank}
                title="Individual Counselling"
                description="A confidential, supportive space to navigate personal challenges, life transitions, and emotional concerns, tailored to your needs with a strength-based approach."
                icon={individualIcon}
              ></Card>
            </div>
            <div className="card-prop">
              <Card
                image={blank}
                title="Virtual Counselling"
                description="Flexible and secure online sessions via Google Meet, offering accessible support from the comfort and privacy of your own space."
                icon={virtualIcon}
              ></Card>
            </div>
            <div className="card-prop">
              <Card
                image={blank}
                title="Psychometric Assessments"
                description="Structured assessments that provide insight into abilities, interests, and personality, helping guide educational and career decisions."
                icon={psychometricIcon}
              ></Card>
            </div>
            <div className="card-prop">
              <Card
                image={blank}
                title="Subject Choice Assessment"
                description="For Grade 9 learners: a tailored assessment to align subject choices with individual aptitudes, interests, and personality."
                icon={subjectChoiceIcon}
              ></Card>
            </div>
            <div className="card-prop">
              <Card
                image={blank}
                title="Career Assessment"
                description="For matric learners and adults: a comprehensive evaluation to inform career choices based on aptitudes, values, interests, and experiences."
                icon={careerIcon}
              ></Card>
            </div>
            <div className="card-prop">
              <Card
                image={blank}
                title="Ride with Confidence"
                description="Overcome show nerves, fear, and performance anxiety. As an equestrian and therapist, I use fast-acting BrainWorking Recursive Therapy® (BWRT) to build your confidence and focus in the saddle."
                icon={Equestrian}
              ></Card>
            </div>
          </div>
          <button
            className="learn-more-services-button"
            onClick={() => (window.location.href = "/services")}
          >
            Learn More About Services
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LandingPage;
